import TB from '@tiger/bridge';
import { useMount } from '@tiger/hooks';
import React from 'react';
import { Link } from 'react-router-dom';
import errorIcon from 'static/images/icons/fail.png';
import APP from 'stores/APP';
import { Source } from 'types/funding';
import { printf } from 'utils/i18n';
import './style.scss';

type BusinessType = 'ACH' | 'Wire' | 'Transfer';

const typeMap: Record<BusinessType, string> = {
    ACH: __('ACH'),
    Wire: __('Wire'),
    Transfer: __('Position Transfer')
};

const BlackListWarning: React.FC<{
    source: Source;
    type: BusinessType;
}> = ({ source, type }) => {
    useMount(() => {
        document.querySelector('#ach-warning-send-email')?.addEventListener('click', () => {
            if (APP.isTiger) {
                if (window.TigerBridge?.shareEmailV2) {
                    TB.shareEmailV2({
                        subject: '',
                        content: '',
                        recipients: ['support@tradeup.com']
                    });
                } else {
                    // 发送邮件不用默认主题和内容，但该方法不支持同时为空字符串
                    TB.shareEmail('', ' ');
                }
            } else {
                window.location.href = 'mailto:support@tradeup.com';
            }
        });
    });

    return (
        <div className="black-list-warning-root">
            <img src={errorIcon} alt="error" className="icon-error" />
            <div className="sub-title">{printf(__('Your %s function is temporarily disabled.'), typeMap[type])}</div>
            <p className="desc">
                <span
                    dangerouslySetInnerHTML={{
                        __html: __(
                            'Please contact customer service via <span class="link" id="ach-warning-send-email">support@tradeup.com</span> for more information.'
                        )
                    }}></span>
                {source === 'deposit' && (
                    <span>
                        {__('Or use')}
                        <Link to="/profile/deposit/USD">{__('Wire Transfer.')}</Link>
                    </span>
                )}
            </p>
            {/* 不用做国际化，中文同英文展示 */}
            <div className="footer">TradeUP Securities, Inc. is a member of SPIC</div>
        </div>
    );
};

export default BlackListWarning;
